import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Ech0134meldungsempfaengerService, MeldungsEmpfaengerDetailEntry } from '../../core/grundbuchmeldung-api';
import { Observable } from 'rxjs';

@Injectable()
export class MeldungsempfaengerResolver {
  constructor(private backend: Ech0134meldungsempfaengerService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<MeldungsEmpfaengerDetailEntry> | Promise<MeldungsEmpfaengerDetailEntry> | MeldungsEmpfaengerDetailEntry {
    return this.backend.loadEmpfaenger(route.paramMap.get('id'));
  }
}
